class MemoryStorage {
  data = new Map();

  size() {
    return this.data.size;
  }

  get(key) {
    if (this.data.has(key)) {
      return this.data.get(key);
    }
    return null;
  }

  has(key) {
    return this.data.has(key);
  }

  set(key, value) {
    this.data.set(key, value);
  }

  remove(key) {
    return this.data.delete(key);
  }

  clear() {
    this.data.clear();
  }
}

const memoryStorage = new MemoryStorage();

export default memoryStorage;
